export default __webpack_public_path__ + "static/media/gas-meter.5b1b12e4.png";